// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "./" + chunkId + "." + {"253": "4dc8c5115c754881","316": "e85e4aca45330624","585": "9ab5e14effafccf8",}[chunkId] + ".css"
}